import _get from 'lodash-es/get';
import { connect } from 'react-redux';
// import { openErrorToast } from '../../../../../../../../reducers/uiLogic';
import VoucherProgram from './VoucherProgram';
import { openErrorToast } from '../../../../../../../reducers/uiLogic';
import {
  createProgramInitiate,
  getProgramInfoInitiate,
  reviewProgramInitiate,
} from '../../../../../../../actions/programs';
import { getAllGroupsInitiate } from '../../../../../../../actions/groups';
import { currentFlowTypeEnum } from '../../../../../../common/components/constants';

const mapStateToProps = state => {
  const groupsData = _get(state, 'groups', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const programInfo = _get(state, 'programs.programInfo', {});
  const { programs = {} } = state;
  const { reviewProgramDetails = {} } = programs;
  const flowType = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  const questionsData = _get(state, 'questions.questionsData', []);
  return {
    flowType,
    reviewProgramDetails,
    groupsData,
    questionsData,
    selectedWorkspace,
    fetchingWorkspaces:
      _get(state, 'apiState.GET_ALL_WORKSPACES.isFetching', true) &&
      !_get(state, 'apiState.GET_ALL_WORKSPACES.isIdle', false),
    fetchedWorkspaces: _get(state, 'apiState.GET_ALL_WORKSPACES.success', true),
    fetchingGroups:
      _get(state, 'apiState.GET_GROUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUPS.isIdle', false),
    fetchedGroups: _get(state, 'apiState.GET_GROUPS.success', true),
    creatingProgram:
      _get(state, 'apiState.CREATE_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.CREATE_PROGRAM.isIdle', true),
    reviewingProgram:
      _get(state, 'apiState.REVIEW_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.REVIEW_PROGRAM.isIdle', true),
    reviewProgramSuccess: _get(state, 'apiState.REVIEW_PROGRAM.success', false),
    createProgramSuccess: _get(state, 'apiState.CREATE_PROGRAM.success', false),
    programInfo,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  createProgram: payload => dispatch(createProgramInitiate(payload)),
  reviewProgram: payload => dispatch(reviewProgramInitiate(payload)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VoucherProgram);
